<div class="flex login-page">
  <div class="left-section">
    <div class="intro-title relative z-1 text-2xl"> Welcome to the Transportation Portal</div>
    <div class="intro-label relative z-1">{{signInDescription}}</div>
    <div class="login-banner-img">
      <img src="/assets/images/temp/login-img2.png" alt="">
    </div>
  </div>

  <div class="right-section scroll-bar-css">
      <!-- <div class="right-logo">
        <img class="right-logo-style" [src]="logoPath" alt="">
      </div> -->
    <div class="signin-box-inner-container">
      <div class="brand-right-logo">
        <img class="right-logo-style" [src]="logoPath" alt="">
      </div>
      <div class="col-12  sign-in-text">
        <div class="lg:col-12 sign-in-content text-center welcome-back">
        Transport Login</div>
        <div class="lg:col-12 sign-in-content flex justify-content-center"><div class="">
          Login to manage your fleet, drivers, and bookings effortlessly
        </div></div>
      </div>
      <div class="col-12">
        <div class="col-12 md:col-12 lg:col-12">
          <p-panel>
            <!-- <div class="form-field col-12 ">
              <div class="text-center"><img id="brand_logo" src="/assets/images/temp/MI_black_logo.png"></div>
              <div id="login_text" class="form-field col-12 switch-btn">Login</div>
            </div> -->
            <div id="sign-in-general-err" class="form-field col-12 p-0">
              <div class="form-errors alert alert-danger" [hidden]='!loginErrors[0]["general"]'>
                @for (ErrorMessage of loginErrors['general']; track ErrorMessage) {
                  <div id="login_error_message">
                    {{ErrorMessage.message}}
                  </div>
                }
              </div>
            </div>
            <div class="form-field col-12 p-0">
              <div class="form-errors alert alert-danger" [hidden]='!loginErrors[0]["email"]'>
                @for (ErrorMessage of loginErrors['email']; track ErrorMessage) {
                  <div id="login_error_email_message">
                    {{ErrorMessage.message}}
                  </div>
                }
              </div>
            </div>
            <app-login (onSignInEmitter)="doSignIn($event)" (onForgotPasswordEmitter)="forgotPassword()"></app-login>
            <div style="clear: both;"></div>
          </p-panel>
        </div>
      </div>
      <div class="col-12 sign-in-text relative">
        <a [href]="signInService.poweredByRedirectBeforeLoginUrl" target="_blank" style="font-size: 32px;" class="sign-in-content fixed bottom-0" style="left: 70%;">
          <img id="mi_logo" width="150" [src]="poweredByBeforeLogoUrl">
        </a>
      </div>
    </div>
  </div>
</div>

<p-dialog modal="false" styleClass="edit-popup" position="center center"   [(visible)]="forgotPopup"
  [closable]="false">
  <p-header id="labelResetPassword">{{labelResetPassword}} </p-header>
  <app-forgot-password (onPopClose)="onPopClose($event)" (onPopSave)="onPopSave($event)"></app-forgot-password>
</p-dialog>

<p-dialog modal="false" styleClass="edit-popup" position="center center"   [(visible)]="otpPopup"
  [closable]="false" [contentStyle]="{'width': '500px'}">
  <p-header id="labelValidateOtp">{{labelValidateOtp}}</p-header>
  <app-otp-verifiy [email]="otpEmail" [phone]="otpPhone" (onOtpPopClose)="onOtpPopClose($event)"
  (onOtpPopSave)="onOtpPopSave($event)"></app-otp-verifiy>
</p-dialog>

<p-dialog modal="false" styleClass="edit-popup" position="center center"
  [(visible)]="setPasswordPopup" [closable]="false">
  <p-header id="labelResetPassword">{{labelResetPassword}}</p-header>
  <app-set-password [otpId]="otpId" (onSetPasswordPopClose)="onSetPasswordPopClose($event)"></app-set-password>
</p-dialog>
